// extracted by mini-css-extract-plugin
export default {"stepItemIcon":"RequestJobPostingAnalysis_stepItemIcon__OQwVv","stepItemIconSvg":"RequestJobPostingAnalysis_stepItemIconSvg__WBAOJ"};